import { createFileRoute } from '@tanstack/react-router'
import AssetUpload from 'Asset/components/asset/Sections/AssetUpload'

export const Route = createFileRoute('/assets/$id/replace')({
    component: AssetUpload,
})
